function showColorPicker(mouseX, mouseY) {
    const colorPicker = document.getElementById("colorPicker");
    if (!colorPicker) {
        return;
    }

    // Setze die korrekte Position basierend auf der Mausposition + Scroll-Korrektur
    colorPicker.style.left = `${mouseX + window.scrollX}px`;
    colorPicker.style.top = `${mouseY + window.scrollY}px`;

    // Zeige das Farb-Popup an
    colorPicker.classList.add("show");
}

function hideColorPicker() {
    const colorPicker = document.getElementById("colorPicker");
    if (colorPicker) {
        colorPicker.classList.remove("show");
    }
}

function scrollToCanvas() {
    if (window.innerWidth <= 768) { // Nur bei mobilen Geräten
        const canvasEl = document.getElementById("canvas-container");
        if (canvasEl) {
            canvasEl.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }
}


function changeIllustrationTemporary() {
    const illustration = document.getElementById("illustration-img");

    if (!illustration) return;

    let originalSrc = "https://cdn.shopify.com/s/files/1/0553/6556/6511/files/bygge_Krake_mit_Sprechblase_Farben_aendern_Augen_seitlich.png?v=1742292429";
    let newSrc = "https://cdn.shopify.com/s/files/1/0553/6556/6511/files/bygge_Krake_mit_Sprechblase_Farben_aendern_offener_Mund.png?v=1742388221";

    // Direkt wechseln, falls es noch nicht gesetzt ist
    if (illustration.src !== newSrc) {
        illustration.src = newSrc;
    }

    // Nach 1 Sekunde zurück zum Originalbild
    setTimeout(() => {
        if (illustration.src !== originalSrc) {
            illustration.src = originalSrc;
        }
    }, 1000);
}


let baseColors = ["#E51AAA", "#F87828", "#092F50", "#38B87D", "#9BD4BA", "#EFDA03"];


function applyRandomColors(colorCount) {

    if (colorCount < 2 || colorCount > 4) {
        return;
    }

    let selectedRandomColors = [];
    while (selectedRandomColors.length < colorCount) {
        let randomColor = baseColors[Math.floor(Math.random() * baseColors.length)];
        if (!selectedRandomColors.includes(randomColor)) {
            selectedRandomColors.push(randomColor);
        }
    }

    let bausteine = [];

    scene.traverse((child) => {
        if (child.isMesh) {
            let mainObject = child;
            while (mainObject.parent && mainObject.parent !== scene) {
                mainObject = mainObject.parent;
            }

            if (!bausteine.includes(mainObject)) {
                bausteine.push(mainObject);
            }
        }
    });

    for (let i = 0; i < bausteine.length; i++) {
        let color = selectedRandomColors[i % selectedRandomColors.length];

        // Farbe setzen
        bausteine[i].traverse((part) => {
            if (part.isMesh && part.material) {
                part.material.color.set(color);
                part.material.needsUpdate = true;
            }
        });

        // Farbe für den Warenkorb speichern
        selectedColors[bausteine[i].userData.name] = color.toUpperCase();
    }

    updateSelectedColors();
}






// Bausteine einfärben
function applyColors(colors) {
    let i = 0;
    scene.traverse((child) => {
        if (child.isMesh) {
            child.material.color.set(colors[i % colors.length]);
            child.material.needsUpdate = true;
            i++;
        }
    });
    updateSelectedColors();
}

function updateSelectedColors() {
    let selectedColors = {}; // Sicherstellen, dass die Map immer neu befüllt wird

    scene.traverse((child) => {
        if (child.isMesh && child.userData.name) {
            let mainObject = child;
            while (mainObject.parent && mainObject.parent !== scene) {
                mainObject = mainObject.parent;
            }

            // Farbe aus dem Material holen
            let colorHex = mainObject.children.find(c => c.isMesh)?.material.color.getHexString().toUpperCase();
            if (colorHex) {
                selectedColors[mainObject.userData.name] = `#${colorHex}`;
            }
        }
    });

}




// Scene, Camera & Renderer erstellen
const scene = new THREE.Scene();
const aspectRatio = window.innerWidth / window.innerHeight;


scene.background = new THREE.Color(0xede5dc);

let camera = new THREE.PerspectiveCamera(45, innerWidth / innerHeight, 1, 1000);

const renderer = new THREE.WebGLRenderer({ canvas: document.getElementById("three-canvas") });


renderer.setSize(window.innerWidth, window.innerHeight);
renderer.setPixelRatio(window.devicePixelRatio);
renderer.shadowMap.enabled = true; 
renderer.shadowMap.type = THREE.PCFSoftShadowMap; // Weiche Schatten


// GLTF-Loader
const loader = new THREE.GLTFLoader();
const bausteine = [];


// Model-Pfade und Anzahl der Bausteine
const modelPaths = [
    { name: "LILLE", path: "https://cdn.shopify.com/3d/models/78ab1852db49e860/lille.glb", count: 4 },
    { name: "SKRAPLAN", path: "https://cdn.shopify.com/3d/models/ad2cea6bbb2144ba/skraplan.glb", count: 2 },
    { name: "STOR", path: "https://cdn.shopify.com/3d/models/ee1af1d52167c494/stor.glb", count: 2 },
    { name: "BESLAG", path: "https://cdn.shopify.com/3d/models/1e5df2e85e113916/beslag.glb", count: 4 }
];
   
const productVariants = {
    "LILLE": {
        "#E51AAA":   48413483598149,  // Variant ID für LILLE Pink
        "#F87828": 41292959252527,
        "#092F50":   41292959154223,
        "#38B87D":  41292959219759,
        "#9BD4BA":   48528644047173,
        "#EFDA03":  41292959186991
    },
    "SKRAPLAN": {
        "#E51AAA": 48413463642437,  // Variant ID für SKRAPLAN Pink
        "#F87828": 41292981108783,
        "#092F50": 41292981010479,
        "#38B87D": 41292981076015,
        "#9BD4BA": 48528646766917,
        "#EFDA03": 41292981043247
    },
   "STOR": {
        "#E51AAA": 48413476979013,  // Variant ID für STOR Pink
        "#F87828": 41284235132975,
        "#092F50": 41284235034671,
        "#38B87D": 41284235100207,
        "#9BD4BA": 48528642965829,
        "#EFDA03": 41284235067439
    },
   "BESLAG": {
        "#E51AAA": 48413468885317,  // Variant ID für BESLAG Pink
        "#F87828": 41292977143855,
        "#092F50": 41292977045551,
        "#38B87D": 41292977111087,
        "#9BD4BA": 48528649191749,
        "#EFDA03": 41292977078319
    }
};


// Sanftes Licht von oben links
const softLight = new THREE.DirectionalLight(0xffffff, 1);
softLight.position.set(15, 25, 15); 
softLight.castShadow = true;

// Weiche Schatten für einen natürlicheren Look
softLight.shadow.mapSize.width = 4096;
softLight.shadow.mapSize.height = 4096;
softLight.shadow.radius = 10;
softLight.shadow.camera.near = 1;
softLight.shadow.camera.far = 50;

scene.add(softLight);

// Sanftes Licht von unten links
const softLight2 = new THREE.DirectionalLight(0xffffff, 0.5);
softLight2.position.set(5, 15, 5); 
softLight2.castShadow = true;

// Weiche Schatten für einen natürlicheren Look
softLight2.shadow.mapSize.width = 4096;
softLight2.shadow.mapSize.height = 4096;
softLight2.shadow.radius = 10;
softLight2.shadow.camera.near = 1;
softLight2.shadow.camera.far = 50;

scene.add(softLight2);

let modelCount = {}; // Zählt, wie oft ein Modell existiert

let loadedModels = 0; // Zählt geladene Modelle

modelPaths.forEach((model, index) => {
    if (!modelCount[model.name]) {
        modelCount[model.name] = 0;
    }

    for (let i = 0; i < model.count; i++) {
        loader.load(model.path, function (gltf) {
            let obj = gltf.scene;
            modelCount[model.name] += 1;

            let uniqueName = `${model.name}_${modelCount[model.name]}`;
            obj.name = uniqueName;
            obj.userData = { name: uniqueName };

            // Positionierung beibehalten
            if (index === 1) {
                obj.position.set(index * 2.5, 0, (i * 2.5) - 0.5);
            } else if (index === 2) {
                obj.position.set((index - 1) * 2.5, 0, ((i + 2) * 2.5) - 0.5);
            } else if (index === 3) {
                obj.position.set(index * 2.22, 0, (i * 2.5) - 0.45);
            } else {
                obj.position.set(index * 2.5, 0, i * 2.5);
            }

            obj.scale.set(10, 10, 10);

            obj.traverse((child) => {
                if (child.isMesh) {
                    child.name = `${uniqueName}_Mesh`;
                    child.userData = { name: uniqueName };

                    let mainObject = child;
                    while (mainObject.parent && mainObject.parent !== scene) {
                        mainObject = mainObject.parent;
                    }

                    // Prüfen, ob das Hauptobjekt bereits ein Material hat
                    if (!mainObject.userData.hasCustomMaterial) {
                        let randomColor = baseColors[Math.floor(Math.random() * baseColors.length)];

                        let newMaterial = new THREE.MeshStandardMaterial({
                            color: randomColor,
                            roughness: 0.7,
                            metalness: 0,
                        });

                        mainObject.traverse((part) => {
                            if (part.isMesh) {
                                part.material = newMaterial;
                                part.material.needsUpdate = true;
                            }
                        });

                        // Speichert die zufällige Farbe direkt in selectedColors
                        selectedColors[mainObject.userData.name] = randomColor.toUpperCase();

                        mainObject.userData.hasCustomMaterial = true;
                    }
                }
            });

            bausteine.push(obj);
            scene.add(obj);
            loadedModels++;


            if (loadedModels === modelPaths.reduce((sum, m) => sum + m.count, 0)) {
                updateSelectedColors();
            }
        });
    }
});






// Kamera korrigieren
camera.position.set(12, 26, 12); 
camera.lookAt(0, -15, -1);

const effect = new THREE.OutlineEffect(renderer, {
    defaultThickness: 0.0025,  // Dicke der Outline
    defaultColor: [0, 0, 0], // Rot als Outline-Farbe (RGB)
    defaultAlpha: 1,         // Transparenz der Outline (1 = Voll sichtbar)
    defaultKeepAlive: true   // Behalte den Effekt auch bei inaktiven Objekten
});

// Renderer-Funktion überschreiben
function animate() {
    requestAnimationFrame(animate);
    effect.render(scene, camera);
}
animate();


// Raycasting für Klick-Erkennung
const raycaster = new THREE.Raycaster();
const pointer = new THREE.Vector2();
let selectedObject = null;

window.addEventListener("click", function(event) {
    const rect = renderer.domElement.getBoundingClientRect();
    pointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    pointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

    raycaster.setFromCamera(pointer, camera);
    const intersects = raycaster.intersectObjects(scene.children, true);

    if (intersects.length > 0) {
        selectedObject = intersects[0].object;

        // Farb-Popup anzeigen
        showColorPicker(event.clientX, event.clientY);
    } else {
        hideColorPicker();
    }
});


let hoveredObject = null;

window.addEventListener("mousemove", (event) => {
    const rect = renderer.domElement.getBoundingClientRect();
    pointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    pointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

    raycaster.setFromCamera(pointer, camera);
    const intersects = raycaster.intersectObjects(scene.children, true);

    if (intersects.length > 0) {
        const object = intersects[0].object;

        if (hoveredObject !== object) {
            if (hoveredObject) {
                hoveredObject.traverse((child) => {
                    if (child.isMesh) {
                        child.material.emissive.set(0x000000); // Zurücksetzen
                    }
                });
            }

            hoveredObject = object;
            document.body.classList.add("hovered");

            hoveredObject.traverse((child) => {
                if (child.isMesh) {
                    child.material.emissive.set(0x777777); // Leichter Glow
                }
            });
        }
    } else {
        if (hoveredObject) {
            hoveredObject.traverse((child) => {
                if (child.isMesh) {
                    child.material.emissive.set(0x000000);
                }
            });
            hoveredObject = null;
        }
        document.body.classList.remove("hovered");
    }
});






const selectedColors = {}; // Globale Speicherung der Farben

document.querySelectorAll(".color-btn").forEach(button => {
    button.addEventListener("click", function() {
        if (selectedObject) {
            let color = this.getAttribute("data-color");

            // Setze die Materialfarbe des 3D-Modells
            selectedObject.traverse((child) => {
                if (child.isMesh) {
                    child.material.color.set(color);
                }
            });
            // Globale Speicherung für den Warenkorb
            selectedColors[selectedObject.userData.name] = color;
            changeIllustrationTemporary();
        }
    });
});



document.getElementById("addToCart").addEventListener("click", function() {
    let cartItems = [];
    let bausteine = new Set();

    scene.traverse((obj) => {
        if (obj.isMesh && obj.userData.name) {
            let mainObject = obj;
            while (mainObject.parent && mainObject.parent !== scene) {
                mainObject = mainObject.parent;
            }

            bausteine.add(mainObject);
        }
    });


    Array.from(bausteine).forEach((baustein) => {
        let blockName = baustein.userData.name.split("_")[0];
        let color = selectedColors[baustein.userData.name]; // Farbe aus `selectedColors` holen

        if (!color) {
            return;
        }

        let variantId = productVariants[blockName]?.[color];
        if (variantId) {
            cartItems.push({ id: variantId, quantity: 1 });
        }
    });

    if (cartItems.length !== 12) {
        alert(`❌ Es wurden nur ${cartItems.length} von 12 Bausteinen erkannt! Bitte überprüfe die Farben.`);
        return;
    }

    fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: cartItems })
    }).then(response => response.json())
      .then(data => {
          window.location.href = "/cart";
      })
      .catch(() => {});
});




window.addEventListener("resize", () => {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
});


// Farbkonstellationen
const presets = {
    1: { // TOMKE
        LILLE: ["#092F50", "#F87828", "#38B87D", "#EFDA03"],
        BESLAG: ["#092F50", "#F87828", "#38B87D", "#EFDA03"],
        STOR: ["#092F50", "#F87828"],
        SKRAPLAN: ["#38B87D", "#EFDA03"]
    },
    2: { // JOSSE
        LILLE: ["#E51AAA", "#F87828", "#9BD4BA", "#EFDA03"],
        BESLAG: ["#E51AAA", "#F87828", "#9BD4BA", "#EFDA03"],
        STOR: ["#E51AAA", "#F87828"],
        SKRAPLAN: ["#9BD4BA", "#EFDA03"]
    },
    3: { // NELE
        LILLE: ["#E51AAA", "#38B87D", "#9BD4BA", "#092F50"],
        BESLAG: ["#E51AAA", "#38B87D", "#9BD4BA", "#092F50"],
        STOR: ["#E51AAA", "#38B87D"],
        SKRAPLAN: ["#9BD4BA", "#092F50"]
    }
};



function applyPreset(presetId) {
    const selectedPreset = presets[presetId];
    if (!selectedPreset) {
        return;
    }

    let bausteinGruppen = {
        LILLE: [],
        BESLAG: [],
        STOR: [],
        SKRAPLAN: []
    };

    // 1️⃣ **Nur Hauptobjekte sammeln (keine mehrfachen Einträge)**
    let uniqueObjects = new Set();

    scene.traverse((child) => {
        if (child.isMesh && child.userData.name) {
            let mainObject = child;
            while (mainObject.parent && mainObject.parent !== scene) {
                mainObject = mainObject.parent;
            }

            if (!uniqueObjects.has(mainObject)) {
                uniqueObjects.add(mainObject);

                let blockName = mainObject.userData.name.split("_")[0];
                if (bausteinGruppen[blockName]) {
                    bausteinGruppen[blockName].push(mainObject);
                }
            }
        }
    });

    // 2️⃣ **Gleichmäßige Farbverteilung**
    Object.keys(bausteinGruppen).forEach(blockName => {
        let bausteine = bausteinGruppen[blockName];
        let colorList = selectedPreset[blockName];

        if (!colorList || bausteine.length === 0) return; // Falls keine Farben oder keine Bausteine da sind, überspringen

        let colorIndex = 0;
        bausteine.forEach((baustein, i) => {
            let color = colorList[colorIndex];
            colorIndex = (colorIndex + 1) % colorList.length; // Nächste Farbe rotieren

            // Farbe setzen (nur Hauptobjekt)
            baustein.traverse((part) => {
                if (part.isMesh) {
                    part.material.color.set(color);
                    part.material.needsUpdate = true;
                }
            });

            // Farbe für den Warenkorb speichern
            selectedColors[baustein.userData.name] = color.toUpperCase();
        });
    });

    updateSelectedColors();
}




// Farb-Preset-Buttons
document.querySelectorAll(".preset-img").forEach((img) => {
    img.addEventListener("click", function () {
        const presetId = this.getAttribute("data-preset");
        applyPreset(presetId);
        changeIllustrationTemporary();
        scrollToCanvas(); 
    });
});

document.querySelectorAll(".random-color-img").forEach((img) => {
    img.addEventListener("click", function () {
        const colorCount = parseInt(this.getAttribute("data-count"));
        applyRandomColors(colorCount);
        changeIllustrationTemporary();
        scrollToCanvas(); 
    });
});



// "In den Warenkorb"-Button
document.getElementById("addToCart").addEventListener("click", function () {
    //alert("🛒 Dein Set wurde in den Warenkorb gelegt!");
});

// Instagram-Share Button
//document.getElementById("shareInstagram").addEventListener("click", function () {
//    alert("📷 Mache einen Screenshot und teile dein Set auf Instagram!");
//});



window.onload = function () {
   updateSelectedColors();
};
